export const aboutData = {
    title: "Who I am",
    description1: "Eko Setiaji, AMK, C.SMC, RN.Dev. Saya perawat yang memiliki ketrampilan sunat modern bersertifikat, dan seorang software engineer dari Karawang Indonesia",
    description2: "Kegiatan saya bekerja di rumah sakit swasta dan mengembangkan platform digital Ethan Shop Mobile App yang bergerak di bidang Kesehatan, Pendidikan dan E-Commerce.",
    image: 1
}